import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Sep 18 2018
 * @author SKu
 */
import { jsonConversions } from '@logio/common-be-fe';
import { GenericTransportLayer } from './GenericTransportLayer';
import api from '../api';
import logger from '../logger';
export var CRUTransportLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(CRUTransportLayer, _GenericTransportLaye);

  /**
   * @param baseUri Endpoint where we can find all results and base for other api requests like modalData
   */
  function CRUTransportLayer(baseUri) {
    var _this;

    _classCallCheck(this, CRUTransportLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CRUTransportLayer).call(this, baseUri));
    _this.baseUri = baseUri;
    return _this;
  }

  _createClass(CRUTransportLayer, [{
    key: "create",
    value: function create(item) {
      var _this2 = this;

      var document = this.getConverter().toDocument(item, jsonConversions);
      var createPromise = api("".concat(this.baseUri)).post(item.numericId ? Object.assign(Object.assign({}, document), {
        numericId: item.numericId
      }) : document, {
        responseType: 'json'
      }).then(function (response) {
        return _this2.getConverter().toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return createPromise;
    }
  }, {
    key: "update",
    value: function update(item) {
      var _this3 = this;

      var document = this.getConverter().toDocument(item, jsonConversions);
      var updatePromise = api("".concat(this.baseUri, "/").concat(item.id)).put(document, {
        responseType: 'json'
      }).then(function (response) {
        return _this3.getConverter().toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return updatePromise;
    }
  }]);

  return CRUTransportLayer;
}(GenericTransportLayer);